module.exports = __webpack_public_path__ + "c5369082eb6eb435b7064de25dbd880d.png";